/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgCircleCancelIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.999 1C18.0735 1.00005 22.998 5.92456 22.998 11.999C22.998 18.0735 18.0735 22.998 11.999 22.998C5.92461 22.9979 1.00005 18.0735 1 11.999C1.00005 5.9246 5.92462 1.00012 11.999 1ZM11.999 2.5C6.75304 2.50012 2.50005 6.75303 2.5 11.999C2.50005 17.245 6.75304 21.4979 11.999 21.498C17.2451 21.498 21.498 17.2451 21.498 11.999C21.498 6.75298 17.2451 2.50005 11.999 2.5ZM14.543 8.39453C14.8359 8.10166 15.3106 8.10165 15.6035 8.39453C15.8961 8.68744 15.8963 9.16227 15.6035 9.45508L13.0586 11.999L15.6035 14.5439C15.8961 14.8369 15.8963 15.3117 15.6035 15.6045C15.3107 15.8971 14.8358 15.897 14.543 15.6045L11.998 13.0596L9.4541 15.6045C9.16128 15.8971 8.68639 15.897 8.39355 15.6045C8.10074 15.3117 8.1009 14.8369 8.39355 14.5439L10.9375 11.999L8.39355 9.45508C8.10073 9.16226 8.10087 8.68744 8.39355 8.39453C8.68645 8.10164 9.16121 8.10164 9.4541 8.39453L11.998 10.9385L14.543 8.39453Z"
      fill={color}
    />
  </svg>
);

export default SvgCircleCancelIcon;
